/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconChartDonut3 = createReactComponent("chart-donut-3", "IconChartDonut3", [
  ["path", { d: "M12 3v5m4 4h5", key: "svg-0" }],
  ["path", { d: "M8.929 14.582l-3.429 2.918", key: "svg-1" }],
  ["path", { d: "M12 12m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0", key: "svg-2" }],
  ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-3" }]
]);

export { IconChartDonut3 as default };
//# sourceMappingURL=IconChartDonut3.js.map
